// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  envName: 'development',
  appVersion: 'v8.6.2-dev',
  production: false,
  hmr: false,
  elasticApm: {
    enabled: true,
    serviceName: 'medmylink-fe',
    serverUrl: 'https://84db6f5e2b3144eeb6695e9e45618cba.apm.westeurope.azure.elastic-cloud.com',
    environment: 'dev',
    serviceVersion: 'v8.6.2-dev',
    distributedTracingOrigins: ['https://devmedapi.essilorlink.com'],
    captureBrowserNetworkFailures: true,
    captureAssetLoadFailures: true,
    orderTrackingSlowLoadThresholdMs: 8000,
    blockedResourceHosts: ['px.ads.linkedin.com:443', 'www.google-analytics.com:443', 'www.google.com:443'],
  },
  baseUrl: 'https://mylinkdev.essilorusa.com/',
  apiUrl: 'https://devmedapi.essilorlink.com/api/v1/',
  orderStatusURL: 'orders/',
  reportingURL: '/api/Report/',
  frameTraceURL: 'frame-trace/',
  orderMetricsURL: 'metrics/qlik/',
  dailyOrderLinkUrl: 'https://myeyedr.sharepoint.com/SitePages/Daily%20Reports.aspx',
  eceChatURL:
    'https://ece.essilorusa.com/system/templates/chat/aqua/index.html?subActivity=Chat&entryPointId=1002&templateName=aqua&ver=v11&locale=en-US',
  eceChatAPI: 'https://ece.essilorusa.com/system/egain/chat/entrypoint/agentAvailability/1002',
  mailjet: {
    tenant: 'MYLINK',
    forgotPwTemplateId: 5736356,
    forgotPwSubject: 'MyLink - Forgot Password',
    forgotPwUrl: 'reset-password/',
    from: 'no-reply@essilorusa.com',
  },
  MSAL: {
    clientId: 'ae13754d-422d-4651-9ee0-8fd7e8a94ffd',
    redirectUri: 'https://mylinkdev.essilorusa.com/announcements',
    logoutUri: 'https://mylinkdev.essilorusa.com/login',
    authority: 'https://nab2cdev.b2clogin.com/nab2cdev.onmicrosoft.com/B2C_1A_SIGNIN_MEDMYLINK',
    scopes: ['openid', 'profile', 'ae13754d-422d-4651-9ee0-8fd7e8a94ffd'],
    knownAuthorities: ['nab2cdev.b2clogin.com'],
  },
  pilotFrametraceLoc: 'ALL',
};
